module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-04.86e29a60.png";